var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPinLightAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 5c-4.46 0-8 3.696-8 8.322 0 .99.362 2.265.913 3.632.554 1.372 1.308 2.863 2.116 4.291 1.605 2.838 3.435 5.461 4.34 6.456.142.208.375.299.598.299.23 0 .47-.095.648-.28l.004-.005c.9-.984 2.739-3.594 4.352-6.435.807-1.423 1.562-2.91 2.116-4.288.551-1.371.913-2.658.913-3.67C24 8.696 20.46 5 16 5zm-6.545 8.322c0-3.858 2.93-6.854 6.545-6.854s6.545 2.996 6.545 6.854c0 .72-.273 1.791-.806 3.118-.52 1.296-1.242 2.722-2.03 4.11-1.333 2.348-2.8 4.491-3.708 5.634-.907-1.146-2.374-3.306-3.709-5.667-.788-1.394-1.51-2.824-2.032-4.117-.534-1.326-.805-2.384-.805-3.078z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 13c0 2.178-1.819 4-4 4-2.177 0-4-1.823-4-4 0-2.183 1.819-4 3.994-4C18.18 9 20 10.82 20 13z",
    opacity: 0.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinLightAlt);
export default __webpack_public_path__ + "static/media/MapPin-Light_ALT.f4813910d7c3bcb5758ed1540eccdcdf.svg";
export { ForwardRef as ReactComponent };